import { render, staticRenderFns } from "./OrdersMoveReserveModal.vue?vue&type=template&id=a081b140&scoped=true&"
import script from "./OrdersMoveReserveModal.vue?vue&type=script&lang=js&"
export * from "./OrdersMoveReserveModal.vue?vue&type=script&lang=js&"
import style0 from "./OrdersMoveReserveModal.vue?vue&type=style&index=0&id=a081b140&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a081b140",
  null
  
)

component.options.__file = "OrdersMoveReserveModal.vue"
export default component.exports